import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./login.css";
import { useDispatch, useSelector } from 'react-redux';
import { setPermission } from '../../store/store';

const Login = () => {
  const dispatch = useDispatch();
  const isAdmin = useSelector(state => state.permission.isAdmin);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const url = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(url + '/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({ username, password }),
        credentials: 'include'
      });

      const isJson = response.headers.get('content-type')?.includes('application/json');
      const data = isJson ? await response.json() : { error: await response.text() };

      if (response.ok) {
        dispatch(setPermission({ isAdmin: true }));
        navigate("/admin");
        setPassword('');
      } else {
        console.error('Login failed', data);
        navigate("/login");
        setUsername('');
        setPassword('');
        alert(data.error || "Hibás felhasználónév vagy jelszó!");
      }
    } catch (err) {
      console.error('Login request hiba:', err);
      alert("Bejelentkezési hiba. Ellenőrizd a kapcsolatot vagy a szerver beállításokat.");
    }
  };
  

  return (
    <div className="big-div">
      <div className="login-group">
        <form onSubmit={handleSubmit}>
          <div className="input-group-1">
            <div className="form-group-1">
              <label htmlFor="username-input">Felhasználó:</label>
              <input
                id="username-input"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="form-group-1">
              <label htmlFor="password-input">Jelszó:</label>
              <input
                id="password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group-1">
            <button type="submit">Bejelentkezés</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
